import axios from "axios";
import { API_URL } from "../config/apiConfig";

const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
    };
};

export const getShopProducts = async (affiliateId) => {
    const response = await axios.get(`${API_URL}/shop/products`, {
        params: { affiliateId },
        headers: getAuthHeaders()
    });
    return response.data;
};

export const getAdminShopProducts = async (affiliateId) => {
    const response = await axios.get(`${API_URL}/shop/admin/products`, {
        params: { affiliateId },
        headers: getAuthHeaders()
    });
    return response.data;
};

export const createShopProduct = async (payload) => {
    const response = await axios.post(`${API_URL}/shop/admin/products`, payload, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const updateShopProduct = async (productId, payload) => {
    const response = await axios.put(`${API_URL}/shop/admin/products/${productId}`, payload, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const deleteShopProduct = async (productId) => {
    const response = await axios.delete(`${API_URL}/shop/admin/products/${productId}`, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const adjustShopStock = async (productId, payload) => {
    const response = await axios.post(`${API_URL}/shop/admin/products/${productId}/stock`, payload, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const getShopStatistics = async (affiliateId) => {
    const response = await axios.get(`${API_URL}/shop/admin/statistics`, {
        params: { affiliateId },
        headers: getAuthHeaders()
    });
    return response.data;
};

export const getShopOrders = async (affiliateId) => {
    const response = await axios.get(`${API_URL}/shop/admin/orders`, {
        params: { affiliateId },
        headers: getAuthHeaders()
    });
    return response.data;
};

export const createCreditShopCheckout = async (payload) => {
    const response = await axios.post(`${API_URL}/shop/checkout/credit`, payload, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const createMontonioShopCheckout = async (payload) => {
    const response = await axios.post(`${API_URL}/shop/checkout/montonio`, payload, {
        headers: getAuthHeaders()
    });
    return response.data;
};

export const getShopCheckoutStatus = async (params) => {
    const response = await axios.get(`${API_URL}/shop/checkout/status`, {
        params,
        headers: getAuthHeaders()
    });
    return response.data;
};
